import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 16 17'
    width={size || width}
    height={size || height}
    {...props}
  >
    <g fill='currentColor' fillRule='evenodd' clipPath='url(#prefix__clip0_6361_1665)' clipRule='evenodd'>
      <path d='M8.517 1.871a4 4 0 0 1 5.656 5.656l-.008.008-2 2a4 4 0 0 1-6.032-.432.667.667 0 0 1 1.068-.798 2.667 2.667 0 0 0 4.02.288h.001l1.996-1.996a2.666 2.666 0 0 0-3.772-3.77L8.303 3.963a.667.667 0 1 1-.94-.945l1.147-1.14z' />
      <path d='M5.266 5.62A4 4 0 0 1 9.867 6.97.667.667 0 1 1 8.8 7.77a2.667 2.667 0 0 0-4.022-.288L2.783 9.478a2.667 2.667 0 0 0 3.77 3.77l1.136-1.135a.667.667 0 0 1 .943.943l-1.14 1.14-.009.008a4 4 0 0 1-5.656-5.656l.009-.009 2-2a4 4 0 0 1 1.43-.92' />
    </g>
  </svg>
)
export default SvgComponent
